"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BenchmarkSunSpider = void 0;
var BenchmarkBase_1 = require("./BenchmarkBase");
var BenchmarkSunSpider = /** @class */ (function (_super) {
    __extends(BenchmarkSunSpider, _super);
    function BenchmarkSunSpider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BenchmarkSunSpider.prototype.createStartFunctionCode = function (code) {
        var sunSpiderCPUWarmup = "\n            var warmupMS = 20;\n            for (var start = Date.now(); Date.now() - start < warmupMS;) {\n                for (var i = 0; i < 100; ++i) {\n                    if (Math.atan(Math.acos(Math.asin(Math.random()))) > 4) {\n                        return;\n                    }\n                }\n            }        \n            ";
        return "\n            ".concat(sunSpiderCPUWarmup, "\n\n            var __data = {sum: 0, n: 0};\n            for (var i = 0; i < 20; ++i) {\n                var __time_before = Date.now();\n                ").concat(code, "\n                var __time_after = Date.now();\n                __data.sum += Math.max(__time_after - __time_before, 1);\n                ++__data.n;\n            }\n            return __data.sum / __data.n;\n        ");
    };
    return BenchmarkSunSpider;
}(BenchmarkBase_1.BenchmarkBase));
exports.BenchmarkSunSpider = BenchmarkSunSpider;
//# sourceMappingURL=BenchmarkSunSpider.js.map